import React from 'react';

export const Ellipsis = ({ className }: { className?: string }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="3.5" r="2" fill="currentColor" />
    <circle cx="12" cy="12.5" r="2" fill="currentColor" />
    <circle cx="12" cy="21.5" r="2" fill="currentColor" />
  </svg>
);
